module.exports = __webpack_public_path__ + "static/clicks-localisation-csv-feature-news-4f3775a58470df5d8901cd53698f197a.webm";